import Common from '@vendor/js/common';
import { Spinner } from '@vendor/js/spinner';
import { Api } from '@vendor/js/api';
import { i18n } from '@vendor/libs/lang/lang';
import EntityType from '@vendor/js/enums/EntityType';
import { ConfirmSwal, ErrorSwal } from '@vendor/libs/sweetalert2/sweetalert2';
var AvailableReceiverType;
(function (AvailableReceiverType) {
    AvailableReceiverType[AvailableReceiverType["USER"] = 0] = "USER";
    AvailableReceiverType[AvailableReceiverType["HEADQUARTER"] = 1] = "HEADQUARTER";
    AvailableReceiverType[AvailableReceiverType["REGION"] = 2] = "REGION";
    AvailableReceiverType[AvailableReceiverType["ASSOCIATION"] = 3] = "ASSOCIATION";
    AvailableReceiverType[AvailableReceiverType["FUNCTION_GROUP"] = 4] = "FUNCTION_GROUP";
})(AvailableReceiverType || (AvailableReceiverType = {}));
var Step;
(function (Step) {
    Step[Step["TYPE"] = 0] = "TYPE";
    Step[Step["TABLE"] = 1] = "TABLE";
    Step[Step["OPTIONS"] = 2] = "OPTIONS";
})(Step || (Step = {}));
const _MessagesReceiversCommonHandler = (function () {
    let availableReceivers = null;
    let receivers = [];
    const body = $('body');
    const setAvailableReceivers = (a) => {
        availableReceivers = a;
    };
    const availableReceiverTypeToEntityType = (availableReceiverType) => {
        if (availableReceiverType == AvailableReceiverType.ASSOCIATION) {
            return EntityType.ASSOCIATION;
        }
        if (availableReceiverType == AvailableReceiverType.HEADQUARTER) {
            return EntityType.HEADQUARTER;
        }
        if (availableReceiverType == AvailableReceiverType.REGION) {
            return EntityType.REGION;
        }
        return null;
    };
    const setAvailableReceiversFromApi = async () => {
        const spinner = new Spinner();
        try {
            const response = await Api.get('/messages/available-receivers');
            availableReceivers = response.data;
            redrawReceiversTable();
        }
        catch (err) {
            Common.handleErrorResponse(err);
        }
        finally {
            spinner.destroy();
        }
    };
    const addTableRow = (table, data) => {
        const row = $(Common.compileTemplate('available_receiver_row', data));
        table.rows.add(row);
    };
    const setupAddReceiverModals = async () => {
        const modal = $('#add_receivers_modal');
        const table = modal.find('table').DataTable();
        // buttons
        const cancelButton = modal.find(`[data-app-${modal.attr('id')}-action="cancel"]`);
        const submitButton = modal.find(`[data-app-${modal.attr('id')}-action="submit"]`);
        const backButton = modal.find(`[data-app-${modal.attr('id')}-action="back"]`);
        const optionsButton = modal.find(`[data-app-${modal.attr('id')}-action="options"]`);
        // inputs
        // @ts-ignore
        const functionGroupSelect = $('[name="function_group[]"]')[0].tomselect;
        let type = AvailableReceiverType.USER;
        let currentStep = Step.TYPE;
        window.handleCheckbox(table);
        Common.setupModalCancelAlert(modal[0]);
        $('[data-app-receivers="add"]').on('click', function () {
            Common.openModal(modal);
        });
        const getOptions = () => {
            const optionRange = $('[name="option_range"]:checked').val();
            const isGlobal = optionRange == 2;
            const selectedFunctionGroupContexts = functionGroupSelect.getValue();
            return {
                isGlobal: isGlobal ? true : null,
                context: optionRange == 3
                    ? selectedFunctionGroupContexts.length
                        ? selectedFunctionGroupContexts
                        : null
                    : null,
            };
        };
        const updateViews = () => {
            $('[data-app-receivers_view]').hide();
            // hide unnecessary types
            if (!availableReceivers?.entities.filter((e) => e.type == EntityType.HEADQUARTER.value).length) {
                $(`[type="radio"][name="type"][value="${AvailableReceiverType.HEADQUARTER}"]`)
                    .closest('div')
                    .hide();
            }
            if (!availableReceivers?.entities.filter((e) => e.type == EntityType.REGION.value).length) {
                $(`[type="radio"][name="type"][value="${AvailableReceiverType.REGION}"]`)
                    .closest('div')
                    .hide();
            }
            if (!availableReceivers?.entities.filter((e) => e.type == EntityType.ASSOCIATION.value).length) {
                $(`[type="radio"][name="type"][value="${AvailableReceiverType.ASSOCIATION}"]`)
                    .closest('div')
                    .hide();
            }
            if (!availableReceivers?.users.length) {
                $(`[type="radio"][name="type"][value="${AvailableReceiverType.USER}"]`)
                    .closest('div')
                    .hide();
            }
            if (!availableReceivers?.function_groups.filter((fg) => fg.can_send).length) {
                $(`[type="radio"][name="type"][value="${AvailableReceiverType.FUNCTION_GROUP}"]`)
                    .closest('div')
                    .hide();
            }
            // hide/show buttons
            cancelButton.hide();
            backButton.hide();
            optionsButton.hide();
            if (currentStep == Step.TYPE) {
                cancelButton.show();
            }
            else {
                backButton.show();
            }
            if (currentStep == Step.TABLE) {
                if ([
                    AvailableReceiverType.HEADQUARTER,
                    AvailableReceiverType.REGION,
                    AvailableReceiverType.ASSOCIATION,
                ].includes(type)) {
                    if (!optionsButton.find('.badge').length) {
                        optionsButton.append(`<span class="badge badge-warning ms-2"></span>`);
                    }
                    const numberOfOptions = Object.values(getOptions()).filter((o) => o != null).length;
                    optionsButton
                        .find('.badge')
                        .text(numberOfOptions > 0 ? numberOfOptions : '');
                    optionsButton.show();
                }
            }
            // handle steps view
            submitButton.show();
            if (currentStep == Step.TABLE || currentStep == Step.OPTIONS) {
                submitButton.text(i18n.trans('common.add'));
            }
            else {
                submitButton.text(i18n.trans('common.next'));
            }
            if (currentStep == Step.TYPE) {
                $('[data-app-receivers_view="type_selection"]').show();
            }
            if (currentStep == Step.TABLE) {
                $('[data-app-receivers_view="table"]').show();
            }
            if (currentStep == Step.OPTIONS) {
                $('[data-app-receivers_view="options"]').show();
                let isGlobalLabel = '';
                if (type == AvailableReceiverType.HEADQUARTER) {
                    isGlobalLabel = i18n.trans('models/messages.pages.common.receivers.is_global_headquarter');
                }
                else {
                    isGlobalLabel = i18n.trans('models/messages.pages.common.receivers.is_global_region');
                }
                $('[name="option_range"][value="2"]')
                    .closest('div')
                    .find('label')
                    .text(isGlobalLabel);
                let everyoneLabel = '';
                if (type == AvailableReceiverType.HEADQUARTER) {
                    everyoneLabel = i18n.trans('models/messages.pages.common.receivers.everyone_headquarter');
                }
                else if (type == AvailableReceiverType.REGION) {
                    everyoneLabel = i18n.trans('models/messages.pages.common.receivers.everyone_region');
                }
                else {
                    everyoneLabel = i18n.trans('models/messages.pages.common.receivers.everyone_association');
                }
                if ([
                    AvailableReceiverType.HEADQUARTER,
                    AvailableReceiverType.REGION,
                ].includes(type)) {
                    $('[data-app-receivers_options="is_global"]').show();
                }
                else {
                    $('[data-app-receivers_options="is_global"]').hide();
                }
                $('[name="option_range"][value="1"]')
                    .closest('div')
                    .find('label')
                    .text(everyoneLabel);
                const functionGroups = availableReceivers?.function_groups.filter((fg) => fg.entity_type == availableReceiverTypeToEntityType(type)?.value) ?? [];
                functionGroupSelect.clearOptions();
                if (functionGroups.length == 0) {
                    $('[data-app-receivers_options="function_group"]').hide();
                }
                else {
                    $('[data-app-receivers_options="function_group"]').show();
                    functionGroupSelect.addOptions(functionGroups.map((fg) => ({
                        value: fg.id,
                        text: i18n.trans(fg.display_name),
                    })));
                }
            }
        };
        // add available receivers to table
        modal.on('show.bs.modal', async function () {
            if (availableReceivers == null) {
                await setAvailableReceiversFromApi();
            }
            functionGroupSelect.setValue(null);
            functionGroupSelect.clear();
            $('[name="option_range"][value="1"]')
                .prop('checked', true)
                .trigger('change');
            currentStep = Step.TYPE;
            updateViews();
        });
        const redrawAvailableReceiversTable = () => {
            table.clear();
            if (!availableReceivers) {
                return;
            }
            if (type == AvailableReceiverType.USER) {
                for (const user of availableReceivers.users) {
                    if (receivers.find((r) => r.class_name == user.class_name && r.id == user.id)) {
                        continue;
                    }
                    addTableRow(table, {
                        name: user.name,
                        id: user.id,
                        class: user.class_name,
                        type: i18n.trans('models/common.fields.user'),
                        parent: user.members
                            .map((m) => availableReceivers?.entities.find((e) => e.id == m.entity_id)
                            ?.name ?? null)
                            .filter((m) => m)
                            .join(', '),
                    });
                }
            }
            if (type == AvailableReceiverType.HEADQUARTER ||
                type == AvailableReceiverType.REGION ||
                type == AvailableReceiverType.ASSOCIATION) {
                let entityType = null;
                if (type == AvailableReceiverType.HEADQUARTER) {
                    entityType = EntityType.HEADQUARTER.value;
                }
                if (type == AvailableReceiverType.REGION) {
                    entityType = EntityType.REGION.value;
                }
                if (type == AvailableReceiverType.ASSOCIATION) {
                    entityType = EntityType.ASSOCIATION.value;
                }
                for (const entity of availableReceivers.entities) {
                    if (receivers.find((r) => r.class_name == entity.class_name && r.id == entity.id)) {
                        continue;
                    }
                    if (entityType != null) {
                        if (entity.type != entityType) {
                            continue;
                        }
                    }
                    addTableRow(table, {
                        name: entity.name,
                        id: entity.id,
                        class: entity.class_name,
                        type: i18n.trans(EntityType.getByValue(entity.type).getLabel()),
                        parent: entity.parent?.name ?? i18n.trans('common.empty'),
                    });
                }
            }
            if (type == AvailableReceiverType.FUNCTION_GROUP) {
                for (const functionGroup of availableReceivers.function_groups) {
                    if (receivers.find((r) => r.class_name == functionGroup.class_name &&
                        r.id == functionGroup.id)) {
                        continue;
                    }
                    addTableRow(table, {
                        name: i18n.trans(functionGroup.display_name),
                        id: functionGroup.id,
                        class: functionGroup.class_name,
                        type: i18n.trans('models/functions.groups.title'),
                        parent: i18n.trans(EntityType.getByValue(functionGroup.entity_type).getLabel()),
                    });
                }
            }
            table.draw();
        };
        // handle "add" button click action
        submitButton.on('click', function () {
            if (currentStep == Step.TABLE || currentStep == Step.OPTIONS) {
                const checked = table.$('[type="checkbox"]:checked');
                if (checked.length == 0) {
                    ErrorSwal.fire({
                        text: i18n.trans('models/messages.pages.common.receivers.nothing_checked_error'),
                    });
                    return;
                }
                const options = getOptions();
                const context = options.context ? options.context : [null];
                // @ts-ignore
                for (const input of checked) {
                    for (const contextId of context) {
                        const value = $(input).val();
                        //@ts-ignore
                        const parts = value.split('[');
                        const className = parts[0];
                        const id = parseInt(parts[1].slice(0, -1));
                        receivers.push({
                            id,
                            class_name: className,
                            is_global: options.isGlobal ?? false,
                            context_id: contextId,
                        });
                    }
                }
                Common.closeModal(modal);
                redrawReceiversTable();
                syncReceiverInputs();
            }
            if (currentStep == Step.TYPE) {
                type = parseInt(modal.find('[type="radio"][name="type"]:checked').val());
                currentStep = Step.TABLE;
                updateViews();
                redrawAvailableReceiversTable();
                return;
            }
            if (currentStep == Step.TABLE) {
                currentStep = Step.OPTIONS;
                updateViews();
                return;
            }
        });
        // handle "back" button
        backButton.on('click', function () {
            currentStep = currentStep - 1;
            if (currentStep == Step.TYPE) {
                functionGroupSelect.setValue(null);
                functionGroupSelect.clear();
                $('[name="option_range"][value="1"]')
                    .prop('checked', true)
                    .trigger('change');
            }
            updateViews();
        });
        // handle "options" button
        optionsButton.on('click', function () {
            currentStep = Step.OPTIONS;
            updateViews();
        });
        $('[name="option_range"]').on('change', function () {
            if ($(this).val() == 3) {
                Common.showFormElement(modal, 'function_group[]');
            }
            else {
                Common.hideFormElement(modal, 'function_group[]');
            }
        });
        // handle receiver delete button
        body.on('click', '[data-app-receiver="delete"]', function () {
            ConfirmSwal.fire({
                text: i18n.trans('models/messages.pages.common.receivers.delete_confirm'),
            }).then((response) => {
                if (response.isConfirmed) {
                    const className = $(this).attr('data-app-class_name');
                    const id = parseInt($(this).attr('data-app-id') ?? '-1');
                    receivers = receivers.filter((r) => !(r.class_name == className && r.id == id));
                    redrawReceiversTable();
                    syncReceiverInputs();
                }
            });
        });
        // handle receivers delete all button
        body.on('click', '[data-app-receivers="delete_all"]', function () {
            ConfirmSwal.fire({
                text: i18n.trans('models/messages.pages.common.receivers.delete_all_confirm'),
            }).then((response) => {
                if (response.isConfirmed) {
                    receivers = [];
                    redrawReceiversTable();
                    syncReceiverInputs();
                }
            });
        });
    };
    const syncReceiverInputs = () => {
        $('[name="receivers"]').val(JSON.stringify(receivers));
    };
    const redrawReceiversTable = () => {
        const table = $('[data-app-receivers="table"]').DataTable();
        table.clear();
        if (!availableReceivers) {
            return;
        }
        // group receivers by class_name and id
        const grouped = receivers.reduce((acc, obj) => {
            // create a key from className and id
            let key = obj.class_name + '_' + obj.id;
            // if the key does not exist in the accumulator, create an array for it
            if (!acc[key]) {
                acc[key] = [];
            }
            // push the current object onto the array for this key
            acc[key].push(obj);
            return acc;
        }, {});
        for (const index in grouped) {
            let [className, id] = index.split('_');
            const r = getReceiverFromAvailable(parseInt(id), className);
            if (!r) {
                continue;
            }
            let options = [];
            if (grouped[index][0].is_global &&
                [
                    AvailableReceiverType.HEADQUARTER,
                    AvailableReceiverType.REGION,
                ].includes(r.type)) {
                options = [
                    ...options,
                    r.type == AvailableReceiverType.HEADQUARTER
                        ? i18n.trans('models/messages.pages.common.receivers.is_global_headquarter')
                        : i18n.trans('models/messages.pages.common.receivers.is_global_region'),
                ];
            }
            const functionGroups = [];
            for (const receiver of grouped[index]) {
                if (receiver.context_id) {
                    const functionGroup = availableReceivers?.function_groups.find((fg) => fg.id == receiver.context_id &&
                        fg.entity_type == availableReceiverTypeToEntityType(r.type)?.value);
                    if (functionGroup) {
                        functionGroups.push(functionGroup.display_name);
                    }
                }
            }
            if (functionGroups.length) {
                options = [
                    ...options,
                    i18n.trans('models/messages.pages.common.receivers.only_function_group', {
                        function_group: functionGroups
                            .map((fg) => i18n.trans(fg).toLowerCase())
                            .join(', '),
                    }),
                ];
            }
            const row = $(Common.compileTemplate('receiver_row', {
                name: r.name,
                className: r.className,
                id: r.id,
                additional_data: options.length
                    ? options.join(', ')
                    : i18n.trans('common.empty'),
            }));
            table.rows.add(row);
        }
        table.draw();
    };
    const addReceiver = () => { };
    const setReceivers = (r) => {
        receivers = r;
        redrawReceiversTable();
        syncReceiverInputs();
    };
    const getReceivers = () => {
        return receivers;
    };
    const getReceiverFromAvailable = (id, className) => {
        if (!availableReceivers) {
            return null;
        }
        let receiver = null;
        // try from user
        receiver = availableReceivers.users.find((u) => u.class_name == className && u.id == id);
        if (receiver) {
            return {
                id,
                className,
                name: receiver.name,
                type: AvailableReceiverType.USER,
            };
        }
        // try from entity
        receiver = availableReceivers.entities.find((u) => u.class_name == className && u.id == id);
        if (receiver) {
            return {
                id,
                className,
                name: receiver.name,
                type: receiver.type == EntityType.HEADQUARTER.value
                    ? AvailableReceiverType.HEADQUARTER
                    : receiver.type == EntityType.REGION.value
                        ? AvailableReceiverType.REGION
                        : AvailableReceiverType.ASSOCIATION,
            };
        }
        // try from function group
        receiver = availableReceivers.function_groups.find((u) => u.class_name == className && u.id == id);
        if (receiver) {
            return {
                id,
                className,
                name: `${i18n.trans(receiver.display_name)} (${i18n.trans(EntityType.getByValue(receiver.entity_type).getLabel())})`,
                type: AvailableReceiverType.FUNCTION_GROUP,
            };
        }
    };
    const setupIsGlobalInputChangeEvent = () => {
        $('form [name="is_global"]')
            .on('change', function () {
            if ($(this).is(':checked')) {
                $('[data-app-receivers="container"]').hide();
            }
            else {
                $('[data-app-receivers="container"]').show();
            }
        })
            .trigger('change');
    };
    return {
        // Public functions
        init: function () { },
        setupAddReceiverModals,
        setupIsGlobalInputChangeEvent,
        setAvailableReceivers,
        addReceiver,
        setReceivers,
        getReceivers,
    };
})();
window.MessagesReceiversCommonHandler = _MessagesReceiversCommonHandler;
